import { apiClient } from '@/libs/api_client'
import axios from 'axios'
import { ClinicGroup, CreateClinicGroup, UpdateClinicGroup } from '@magnetar/admin-api-interfaces'

export const clinicGroupService = {
  createClinicGroup: async (data: CreateClinicGroup, token: string) => {
    try {
      const response = await apiClient.post<{ success: boolean; data: ClinicGroup }>(
        '/api/clinic-groups',
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
      }
    }
  },

  updateClinicGroup: async (groupId: number, data: UpdateClinicGroup, token: string) => {
    try {
      const response = await apiClient.put<{ success: boolean; data: ClinicGroup }>(
        `/api/clinic-groups/${groupId}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
      }
    }
  },

  deleteClinicGroup: async (groupId: number, token: string) => {
    try {
      const response = await apiClient.delete<{ success: boolean }>(
        `/api/clinic-groups/${groupId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
      }
    }
  },

  // Clinic assignment
  assignClinic: async (groupId: number, clinicId: number, token: string) => {
    try {
      const response = await apiClient.post<{ success: boolean }>(
        `/api/clinic-groups/${groupId}/clinics/${clinicId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
      }
    }
  },

  removeClinic: async (groupId: number, clinicId: number, token: string) => {
    try {
      const response = await apiClient.delete<{ success: boolean }>(
        `/api/clinic-groups/${groupId}/clinics/${clinicId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
      }
    }
  },

  // Get available clinics for assignment
  getAvailableClinics: async (
    groupId: number,
    params: { search?: string; page?: number; pageSize?: number },
    token: string,
  ) => {
    try {
      const response = await apiClient.get<{
        success: boolean
        data: {
          clinics: Array<{
            clinic_id: number
            clinic_name: string
            address: string
            phone: string
          }>
          total: number
          page: number
          pageSize: number
        }
      }>(`/api/clinic-groups/${groupId}/available-clinics`, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
        data: { clinics: [], total: 0, page: 1, pageSize: 20 },
      }
    }
  },
}
